import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SdkContext from "../../utilities/contexts/sdk/sdkContext";
import Loading from "../Loading";
import { clearPhotoPrivacy } from "../../utilities/helpers/photoPrivacyHelper";
import { getSdkToken, getSdkCallback, getSdkServiceType, getSdkRequestId, clearSdkStorage } from "../../utilities/helpers/sdkStorageHelper";

const SdkLayout: React.FC = () => {
  const [token, setToken] = useState<string | null>(getSdkToken());
  const [loading, setLoading] = useState<boolean>(false);
  const [callback, setCallback] = useState<string | null>(getSdkCallback());
  const [serviceType, setServiceType] = useState<string | null>(getSdkServiceType());
  const [requestId, setRequestId] = useState<string | null>(getSdkRequestId());

  const handleLogin = (newToken: string, newCallback: string, newServiceType: string, newRequestId?: string) => {
    setToken(newToken);
    setCallback(newCallback);
    setServiceType(newServiceType);
    setRequestId(newRequestId || null);
  };

  const handleLogout = () => {
    setToken(null);
    setCallback(null);
    setServiceType(null);
    setRequestId(null);
    clearSdkStorage();
    clearPhotoPrivacy();
  };

  const handleLoading = (newLoading: boolean) => {
    setLoading(newLoading);
  };

  return (
    <SdkContext.Provider
      value={{
        token,
        loading,
        handleLogin,
        handleLogout,
        handleLoading,
        callback,
        serviceType,
        requestId,
      }}
    >
      {loading && <Loading />}
      <Outlet />
    </SdkContext.Provider>
  );
};

export default SdkLayout;
